import React, { Component } from "react";
import ShareModal from "./ShareModal";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

class NormalSmsForm extends Component {
  state = {
    isDisabled: true,
    isShareLinkClicked: false,
    phoneNumber: "",
    id: "",
    disableShare: false,
  };
  userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );

  phonenumber = (inputtxt) => {
    let phoneno = /^\d{10}$/;
    if (inputtxt.match(phoneno)) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  };

  phoneno = (e) => {
    let arry = [];
    let k = e.which;

    for (let i = 48; i < 58; i++) arry.push(i);

    if (!(arry.indexOf(k) >= 0)) e.preventDefault();
  };

  checkNumber = (e) => {
    this.phonenumber(e.target.value);
    this.setState({ phoneNumber: e.target.value });
  };

  checkConfirmation = () => {
    this.setState({ isShareLinkClicked: true });
  };

  shareInstantDoctorAppointMentLink() {
    let doctorId = this.userId;
    let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
    let formData = {
      doctor_id: doctorId,
      link_sharing_medium: "sms",
      phone_number: this.state.phoneNumber,
      amount: String(this.props.amount),
    };
    if (clinicId) {
      formData["clinic_id"] = clinicId;
    }
    this.setState({ disableShare: true });

    afterLoginApiAxios
      .post("/doctor/send-instant-link", formData)
      .then((res) => {
        if (res.data.statusCode === 200) {
          localStorage.setItem("instantConsultId", res.data.instant_consult_id);
          this.setState({ id: res.data.instant_consult_id });
          this.props.history.push({
            pathname:
              this.doctorClinicAssociation &&
              this.doctorClinicAssociation === "false"
                ? `/doctor/video/${res.data.instant_consult_id}`
                : `/clinic/video/${res.data.instant_consult_id}`,
            state: { id: res.data.instant_consult_id },
          });
        }
        this.setState({ disableShare: false });
      })
      .catch((err) => {
        this.setState({ disableShare: false });
        C2CConsole.log(err);
      });
  }

  removeInstantDoctorValue = () => {
    this.props.showDrawer();
    this.setState({ isShareLinkClicked: false });
  };

  render() {
    return (
      <div className="container mt-3 px-0">
        <div className="form-group" style={{ lineHeight: "25px" }}>
          <div
            className="d-flex tag-container  slug-input  align-items-center input_padding"
            style={{ minHeight: "2.5rem" }}
          >
            <span className="p-1 font-weight-bold border-right pr10">+91</span>
            <input
              className="placeholder_style"
              type="tel"
              maxLength={10}
              placeholder="Enter Phone Number"
              onChange={(e) => this.checkNumber(e)}
              onKeyPress={(e) => {
                this.phoneno(e);
              }}
              style={{
                border: "0px",
                width: "100%",
                height: "100%",
                paddingLeft: "10px",
                backgroundColor: "transparent",
              }}
            />
          </div>
          <small className="text-muted mt-1"></small>
        </div>
        <div className="form-group text_area_input">
          <p
            className="rounded mb-3 slug-input input_padding flex_css"
            style={{ minHeight: "2.5rem" }}
          >
            Instant Consultation
          </p>

          <p
            className="rounded slug-input share_link_p input_padding"
            style={{
              minHeight: "70px",
              paddingTop: "15px",
              paddingBottom: "15px",
            }}
          >
            {this.props.name} is now available online. Please visit the url{" "}
            <a href={this.props.slugUrl} target="_blank" rel="noreferrer">
              {this.props.slugUrl}
            </a>{" "}
            to consult.
          </p>
        </div>

        <div className="form-group ">
          <button
            className={`btn  share-button rounded-pill border-0 mt-3 ${
              this.props.amount === "" || this.props.amount === null
                ? "isDisabled_share_btn"
                : ""
            } ${this.state.isDisabled ? "isDisabled_share_btn" : ""}`}
            type="button"
            onClick={() => {
              this.checkConfirmation();
            }}
            style={{ width: "150px", height: "50px" }}
          >
            Share Link
          </button>
        </div>

        <ShareModal
          show={this.state.isShareLinkClicked}
          handleClose={() => this.removeInstantDoctorValue()}
          yesClickHandler={() => this.shareInstantDoctorAppointMentLink()}
          disableShare={this.state.disableShare}
        />
      </div>
    );
  }
}

export default NormalSmsForm;
